import React from 'react';
import { Box, Typography, Grid, Divider } from '@mui/material';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';

const ProfileAccount = ({ empData }) => {
  
  const DetailItem = ({ label, value }) => (
    <Box sx={{ mb: 2 }}>
      <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 600, textTransform: 'uppercase' }}>
        {label}
      </Typography>
      <Typography variant="body1" sx={{ fontWeight: 500, mt: 0.5 }}>
        {value || '--'}
      </Typography>
    </Box>
  );

  return (
    <Box>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 3 }}>
        <AccountBalanceWalletIcon color="primary" />
        <Typography variant="h6" sx={{ fontWeight: 700 }}>Account & Statutory Details</Typography>
      </Box>
      
      <Divider sx={{ mb: 3 }} />
      <Typography variant="subtitle2" color="primary.main" sx={{ fontWeight: 700, mb: 2, textTransform: 'uppercase' }}>
        Statutory Information
      </Typography>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={6} md={3}>
          <DetailItem label="PAN Number" value={empData?.pan_number} />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <DetailItem label="Aadhaar Number" value={empData?.aadhaar_number} />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <DetailItem label="UAN Number" value={empData?.uan_number} />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <DetailItem label="PF Number" value={empData?.pf_number} />
        </Grid>
      </Grid>

      <Divider sx={{ my: 3 }} />
      <Typography variant="subtitle2" color="primary.main" sx={{ fontWeight: 700, mb: 2, textTransform: 'uppercase' }}>
        Bank Details
      </Typography>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={6}>
          <DetailItem label="Bank Name" value={empData?.bank_name} />
          <DetailItem label="Branch Name" value={empData?.branch_name} />
        </Grid>
        <Grid item xs={12} sm={6}>
          <DetailItem label="Bank Account Number" value={empData?.bank_account} />
          <DetailItem label="IFSC Code" value={empData?.ifsc_code} />
        </Grid>
      </Grid>
    </Box>
  );
};

export default ProfileAccount;